import { render, staticRenderFns } from "./WidgetSettingsModal.vue?vue&type=template&id=62512376&scoped=true"
import script from "./WidgetSettingsModal.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsModal.vue?vue&type=style&index=0&id=62512376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62512376",
  null
  
)

export default component.exports